import { render, staticRenderFns } from "./menu-items.html?vue&type=template&id=922774e2&scoped=true&"
import script from "./menu-items.js?vue&type=script&lang=js&"
export * from "./menu-items.js?vue&type=script&lang=js&"
import style0 from "./menu-items.css?vue&type=style&index=0&id=922774e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922774e2",
  null
  
)

export default component.exports